import { useMutation, useQueryClient } from '@tanstack/react-query';
import { aiApi, AISuggestion } from '@/api/ai-api';

export interface SuggestCIDInput {
  diagnosis: string;
  symptoms?: string[];
}

export interface SuggestExamsInput {
  diagnosis: string;
  symptoms?: string[];
}

export interface ReviewSuggestionInput {
  suggestionId: string;
  accepted: boolean;
  reviewedBy: string;
  feedback?: string;
}

export function useSuggestCID() {
  return useMutation<AISuggestion[], Error, SuggestCIDInput>({
    mutationFn: (data: SuggestCIDInput) => aiApi.suggestCID(data),
  });
}

export function useSuggestExams() {
  return useMutation<AISuggestion[], Error, SuggestExamsInput>({
    mutationFn: (data: SuggestExamsInput) => aiApi.suggestExams(data),
  });
}

export function useReviewSuggestion() {
  const queryClient = useQueryClient();

  return useMutation<AISuggestion, Error, ReviewSuggestionInput>({
    mutationFn: (data: ReviewSuggestionInput) => aiApi.reviewSuggestion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai', 'suggestions'] });
    },
  });
}